import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@mui/material/styles';
import { Divider, Grid, HighlightContainer, IconButton, Stack, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';

interface ItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  list: any[];
  onEdit: (i: number) => void;
  onDelete: (i: number) => void;
}

const EditableItem: React.FC<ItemProps> = ({ list, onEdit, onDelete }) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.coverDetailsBusinessLiabilityPlumbing.fields',
  });

  const theme = useTheme();
  return (
    <Stack spacing={2.5}>
      {list.length
        ? list.map((item, index) => (
            <HighlightContainer key={item.number}>
              <Grid container direction="row" textAlign="left">
                <Grid item width="65%">
                  <Typography variant="subtitle2" component="h4" fontWeight="fontWeightMedium">
                    {getTextContent('addedLicences.nameLabel')}
                  </Typography>
                  <Typography>{item.name}</Typography>
                </Grid>
                <Grid
                  item
                  width="35%"
                  display="flex"
                  gap={1.5}
                  justifyContent="flex-end"
                  alignItems="baseline"
                >
                  <IconButton
                    iconProps={{
                      muiIcon: EditIcon,
                      color: theme.palette.text.primary,
                    }}
                    onClick={() => onEdit(index)}
                    data-track="Edit item"
                    name="edit"
                  />
                  <Divider
                    orientation="vertical"
                    sx={{
                      border: '1px solid divider',
                      height: '20px',
                      boxSizing: 'border-box',
                    }}
                  />
                  <IconButton
                    iconProps={{
                      muiIcon: ClearIcon,
                      color: theme.palette.text.primary,
                    }}
                    onClick={() => onDelete(index)}
                    data-track="Delete item"
                    name="clear"
                  />
                </Grid>
                <Grid item width="65%">
                  <Typography variant="subtitle2" component="h4" fontWeight="fontWeightMedium">
                    {getTextContent('addedLicences.numberLabel')}
                  </Typography>
                  <Typography>{item.number}</Typography>
                </Grid>
              </Grid>
            </HighlightContainer>
          ))
        : null}
    </Stack>
  );
};

export default EditableItem;
